// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-text[data-v-2822df23] {\n  color: var(--red);\n}\n.success-text[data-v-2822df23] {\n  font-size: 1.25rem;\n  color: var(--success);\n}\n.align-center[data-v-2822df23] {\n  text-align: center;\n}\n.photo-title[data-v-2822df23] {\n  text-align: center;\n  margin-top: 1rem;\n  text-transform: uppercase;\n  color: var(--brand);\n}\n", ""]);
// Exports
module.exports = exports;
